import { Getters } from "vuex";
import { DirectUploadsGetters, DirectUploadsState } from "./types";

export const getters: Getters<DirectUploadsState, DirectUploadsGetters> = {};
